import { render } from "./UiPageHeader.vue?vue&type=template&id=4b908ad9"
import script from "./UiPageHeader.vue?vue&type=script&lang=js"
export * from "./UiPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__